(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('ViewTravelExpenseModalController', ViewTravelExpenseModalController);

    ViewTravelExpenseModalController.$inject = ['$uibModalInstance', 'expense', 'TravelExpenseService', 'toastr', 'user', 'CurrencyService'];

    function ViewTravelExpenseModalController($uibModalInstance, expense, TravelExpenseService, toastr, user, CurrencyService) {

        var vm = this;
        vm.currentUser            = user;
        vm.expense                = expense;
        vm.cancel                 = cancel;
        vm.newCommentText         = '';
        vm.saveComment            = saveComment;
        vm.saveSalaryAdvance      = saveSalaryAdvance;
        vm.salaryAdvance          = '';
        vm.getExtension           = getExtension;
        vm.checkAtmExchangeRate   = checkAtmExchangeRate;
        vm.copiedToClipboard      = copiedToClipboard;
        vm.getExchangeRate        = getExchangeRate;

        function activate() {

            vm.checkAtmExchangeRate();
        }

        function cancel() {
            $uibModalInstance.close();
        }

        function saveComment() {
            let query = {};
            query['travel_expense_id'] = expense.id;
            query['comment'] = vm.newCommentText;
            TravelExpenseService.saveComment(query).then(function(response) {
                vm.expense.comments = response.data;
                vm.newCommentText = '';
                toastr.success('Successfully saved!');
            });
        }

        function saveSalaryAdvance() {
            let query = {};
            query['expense_id'] = expense.id;
            query['amount'] = vm.salaryAdvance;
            query['currency'] = expense.currency.code;
            query['exchange_rate_usd'] = expense.exchange_rate_usd;
            TravelExpenseService.saveSalaryAdvance(query).then(function(response){
                expense.atm = response.data.atm;
                vm.salaryAdvance = '';
                toastr.success('Successfully saved!');
            });
        }

        function getExtension(file) {
            let ext = file.split('.').pop();
            if(ext == 'jpg' || ext == 'jpeg' || ext == 'gif' || ext == 'png') {
                return true;
            } else {
                return false;
            }
        }

        function getExchangeRate(atm) {
            let query = {};
            query['from'] = atm.currency.code;
            query['to'] = vm.expense.currency.code;
            query['date'] = vm.expense.date;
            return CurrencyService.getExchangeRate(query);
        }

        function checkAtmExchangeRate () {
            vm.expense.atm.map(function(atm) {
                let query = {};
                query['from'] = atm.currency.code;
                query['to'] = vm.expense.currency.code;
                query['date'] = vm.expense.date;
                CurrencyService.getExchangeRate(query).then(function(response) {
                    atm.exchangeRate = response.data;
                    let exchangeRateEquivalentTo = atm.equivalent_to/atm.amount;                  
                    if(((exchangeRateEquivalentTo) > (parseFloat(atm.exchangeRate) + parseFloat(atm.exchangeRate*0.15))) || ((exchangeRateEquivalentTo) < (parseFloat(atm.exchangeRate) - parseFloat(atm.exchangeRate*0.15)))) {
                      atm.doubleCheck = true;
                    } else {
                      atm.doubleCheck = false;
                    }
                });
            });
        }

        function copiedToClipboard () {
            toastr.success('Copied to clipboard!');
        }
        
        activate();
    }

})();